import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Card from "components/card"
import classNames from "classnames"
import {digg} from "diggerize"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import {ScoreFactorGroup} from "models"
import {TagCloud} from "react-tagcloud"

export default memo(shapeComponent(class ComponentsScoreFactorGroupsTagCloud extends ShapeComponent {
  static propTypes = {
    schoolClassCheckInsQuery: PropTypes.object.isRequired,
    scoreFactorGroup: PropTypes.instanceOf(ScoreFactorGroup).isRequired
  }

  setup() {
    this.useStates({
      tagCloudData: undefined
    })

    useMemo(() => {
      this.loadTagCloudData()
    }, [])
  }

  async loadTagCloudData() {
    const response = await this.p.scoreFactorGroup.tagCloud({
      school_class_check_ins_query: this.p.schoolClassCheckInsQuery
    })
    const tagCloudData = digg(response, "tag_cloud_data")

    this.setState({tagCloudData})
  }

  render() {
    const {className, schoolClassCheckInsQuery, scoreFactorGroup, ...restProps} = this.props
    const {tagCloudData} = this.s

    return (
      <Card className={classNames("components--score-factor-groups--tag-cloud", className)} data-tag-cloud={JSON.stringify(tagCloudData)} {...restProps}>
        <div style={{color: "#5253ff"}}>
          {tagCloudData &&
            <TagCloud
              disableRandomColor
              maxSize={50}
              minSize={20}
              tags={tagCloudData}
            />
          }
        </div>
      </Card>
    )
  }
}))
